import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import RichTextReactRenderer from 'components/RichTextReactRenderer';

const useStyles = makeStyles(theme => ({
  contianer: {
    padding: '4px 0',
  },
  text: {
    color: theme.palette.ADACompliantRed,
  },
}));

const DisclaimerEntry = ({ value }) => {
  const classes = useStyles();

  return (
    <Box className={classes.contianer}>
      <RichTextReactRenderer
        data={value}
        fontSize={{
          mobile: 12,
          tablet: 12,
          desktop: 12,
        }}
        className={classes.text}
      />
    </Box>
  );
};

DisclaimerEntry.propTypes = {
  value: PropTypes.string,
};

export default DisclaimerEntry;
